
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#000","d":"M16.751 16.78a2.035 2.035 0 01-2.032-2.033c0-.668.328-1.257.826-1.627l.63 1.826a.61.61 0 101.152-.398l-.631-1.83c.019 0 .036-.004.055-.004a2.034 2.034 0 010 4.066m-9.502 0a2.034 2.034 0 010-4.066c.907 0 1.668.6 1.929 1.422H7.876a.609.609 0 00-.608.61c0 .338.272.61.608.61h1.302a2.029 2.029 0 01-1.929 1.424m9.502-5.287c-.158 0-.31.025-.462.047L14.8 7.22h2.699a.609.609 0 000-1.22H14.23a.819.819 0 00-.663.342.816.816 0 00-.105.737l.643 1.864-3.441 5.193h-.225a3.265 3.265 0 00-1.953-2.395l1.172-1.77h1.032a.61.61 0 000-1.22H7.876a.609.609 0 00-.608.61c0 .337.272.61.608.61h.32L7.184 11.5a3.25 3.25 0 00.065 6.5 3.255 3.255 0 003.19-2.643h.444a.816.816 0 00.678-.364l3.044-4.6.533 1.546a3.244 3.244 0 00-1.637 2.808A3.254 3.254 0 0016.751 18a3.254 3.254 0 000-6.507"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    